function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 384 384",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface30538282"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.000001%,40.000001%,40.000001%)",
      fillOpacity: 1
    },
    d: "M 79.84375 63.84375 C 73.332031 63.84375 67.472656 67.792969 65.023438 73.824219 C 62.574219 79.855469 64.023438 86.773438 68.6875 91.3125 L 169.375 192 L 68.6875 292.6875 C 64.507812 296.699219 62.824219 302.660156 64.285156 308.265625 C 65.746094 313.875 70.125 318.253906 75.734375 319.714844 C 81.339844 321.175781 87.300781 319.492188 91.3125 315.3125 L 192 214.625 L 292.6875 315.3125 C 296.699219 319.492188 302.660156 321.175781 308.265625 319.714844 C 313.875 318.253906 318.253906 313.875 319.714844 308.265625 C 321.175781 302.660156 319.492188 296.699219 315.3125 292.6875 L 214.625 192 L 315.3125 91.3125 C 320.042969 86.710938 321.46875 79.679688 318.894531 73.601562 C 316.324219 67.523438 310.285156 63.648438 303.6875 63.84375 C 299.53125 63.96875 295.585938 65.703125 292.6875 68.6875 L 192 169.375 L 91.3125 68.6875 C 88.300781 65.589844 84.164062 63.84375 79.84375 63.84375 Z M 79.84375 63.84375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.48a9226324e53467722c44d98209fbed.svg";
export { ForwardRef as ReactComponent };